import React from 'react';
import { Button } from "@shared/ui/button";
import { ArrowRight, Check } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

export const Done = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col p-4 items-center text-center">
      <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6 mt-4">
        <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center text-white">
          <Check className="h-6 w-6" strokeWidth={3} />
        </div>
      </div>
      
      <h2 className="text-2xl font-bold text-gray-900 mb-3">{t("Password reset!")}</h2>
      <p className="text-gray-500 text-sm mb-6 max-w-sm">
        {t("Your password has been successfully updated. You can now sign in with your new password.")}
      </p>
      
      <div className="bg-green-50 border border-green-200 rounded-xl p-4 w-full mb-6 text-sm text-green-800 flex flex-col items-center">
        <div className="font-semibold mb-1 text-center">{t("Security confirmation")}</div>
        <div className="text-center">{t("A confirmation email has been sent to {{email}}.", { email: 'mi***@email.com' })}</div>
      </div>
      
      <Button onClick={() => navigate('/login')} className="w-full bg-blue-600 hover:bg-blue-700 h-12 text-base mb-6">
        {t("Sign In Now")} <ArrowRight className="ml-2 h-4 w-4" />
      </Button>
      
      <p className="text-xs text-gray-400">
        {t("If you didn't request this, contact support immediately at ")}<a href="#" className="underline text-gray-500 hover:text-gray-700">(303) 555-0100</a>.
      </p>
    </div>
  );
};
